
import Vue from 'vue'

export default el => Promise.all([
]).then(() => new Vue({
  el,
  data () {
    return {
      activeYear: ''
    }
  },
  mounted () {
    this.activeYear = this.$el.dataset.year
  },
  methods: {
    filterBlogs (year) {
      this.activeYear = `${year}`
    },
    updateYear (e) {
      const year = Number(e.target.value)
      const urlYearStart = Number(this.$el.dataset.urlYearStart)
      if (year >= urlYearStart) {
        window.location.href = `${this.$el.dataset.blogUrl}/tagged/year-${year}`
      }
    }
  }
}))
